import { defineMessages } from "../i18n/core";

export const inviteMessages = defineMessages({
  "pt-BR": {
    loading: "Conferindo o convite…",
    unavailableTitle: "Convite indisponível",
    missingToken: "O link está incompleto. Abra o link do convite exatamente como você recebeu.",
    goToLogin: "Ir para a entrada",
    title: (org: string) => `Convite para ${org}`,
    lede: (role: string, email: string) => `Você foi convidado como ${role}, com o e-mail ${email}.`,
    validUntil: (when: string) => `Válido até ${when}.`,
    existingSignedOut: "Este e-mail já tem conta no E-BACKUP. Entre com ela para aceitar o convite.",
    signInToAccept: "Entrar para aceitar",
    signedInAs: (email: string) => `Você está conectado como ${email}.`,
    accept: "Aceitar convite",
    wrongAccount: (email: string) => `Você está conectado com outra conta. Saia e entre como ${email} para aceitar.`,
    signOut: "Sair",
    createTitle: "Crie sua conta",
    name: "Seu nome",
    password: "Senha",
    passwordHint: "De 12 a 256 caracteres. Uma frase longa é mais segura que uma senha curta complicada.",
    confirmPassword: "Repita a senha",
    mismatch: "As senhas não conferem.",
    continue: "Continuar",
    totpTitle: "Ative a verificação em duas etapas",
    totpLede: "Escaneie o QR code com um aplicativo autenticador (Microsoft Authenticator, Google Authenticator, 1Password) e digite o código de 6 dígitos que ele mostrar.",
    qrLabel: "QR code para o aplicativo autenticador",
    manualKey: "Sem câmera? Digite esta chave no aplicativo:",
    secretLabel: "chave do autenticador",
    code: "Código",
    activate: "Criar conta e entrar",
    working: "Aguarde…",
    failed: "Não foi possível concluir. Tente de novo.",
  },
  "en-US": {
    loading: "Checking the invitation…",
    unavailableTitle: "Invitation unavailable",
    missingToken: "The link is incomplete. Open the invitation link exactly as you received it.",
    goToLogin: "Go to sign in",
    title: (org: string) => `Invitation to ${org}`,
    lede: (role: string, email: string) => `You were invited as ${role}, with the email ${email}.`,
    validUntil: (when: string) => `Valid until ${when}.`,
    existingSignedOut: "This email already has an E-BACKUP account. Sign in with it to accept the invitation.",
    signInToAccept: "Sign in to accept",
    signedInAs: (email: string) => `You are signed in as ${email}.`,
    accept: "Accept invitation",
    wrongAccount: (email: string) => `You are signed in with another account. Sign out and sign in as ${email} to accept.`,
    signOut: "Sign out",
    createTitle: "Create your account",
    name: "Your name",
    password: "Password",
    passwordHint: "12 to 256 characters. A long passphrase is safer than a short complicated password.",
    confirmPassword: "Repeat the password",
    mismatch: "The passwords do not match.",
    continue: "Continue",
    totpTitle: "Turn on two-step verification",
    totpLede: "Scan the QR code with an authenticator app (Microsoft Authenticator, Google Authenticator, 1Password) and enter the 6-digit code it shows.",
    qrLabel: "QR code for the authenticator app",
    manualKey: "No camera? Enter this key in the app:",
    secretLabel: "authenticator key",
    code: "Code",
    activate: "Create account and sign in",
    working: "Please wait…",
    failed: "Could not complete. Try again.",
  },
  es: {
    loading: "Revisando la invitación…",
    unavailableTitle: "Invitación no disponible",
    missingToken: "El enlace está incompleto. Abre el enlace de la invitación tal como lo recibiste.",
    goToLogin: "Ir a iniciar sesión",
    title: (org: string) => `Invitación a ${org}`,
    lede: (role: string, email: string) => `Te invitaron como ${role}, con el correo ${email}.`,
    validUntil: (when: string) => `Válida hasta ${when}.`,
    existingSignedOut: "Este correo ya tiene una cuenta de E-BACKUP. Inicia sesión con ella para aceptar la invitación.",
    signInToAccept: "Iniciar sesión para aceptar",
    signedInAs: (email: string) => `Iniciaste sesión como ${email}.`,
    accept: "Aceptar invitación",
    wrongAccount: (email: string) => `Iniciaste sesión con otra cuenta. Cierra sesión e inicia como ${email} para aceptar.`,
    signOut: "Cerrar sesión",
    createTitle: "Crea tu cuenta",
    name: "Tu nombre",
    password: "Contraseña",
    passwordHint: "De 12 a 256 caracteres. Una frase larga es más segura que una contraseña corta y complicada.",
    confirmPassword: "Repite la contraseña",
    mismatch: "Las contraseñas no coinciden.",
    continue: "Continuar",
    totpTitle: "Activa la verificación en dos pasos",
    totpLede: "Escanea el código QR con una app de autenticación (Microsoft Authenticator, Google Authenticator, 1Password) y escribe el código de 6 dígitos que muestre.",
    qrLabel: "Código QR para la app de autenticación",
    manualKey: "¿Sin cámara? Escribe esta clave en la app:",
    secretLabel: "clave de autenticación",
    code: "Código",
    activate: "Crear cuenta e iniciar sesión",
    working: "Espera…",
    failed: "No se pudo completar. Inténtalo de nuevo.",
  },
});
